// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__39onL","overflowing":"ReadFullNote_overflowing__3zJvv"};